import React from 'react'
export default React.createContext({estate: null, products: []})
